import {Action} from '@ngrx/store';
import {ChecklistItem} from '../../../models/checklist-item';
import {BijbEvent} from '../../../models/bijb-event';

export class RemoveChecklistItemAction implements Action {
  public static readonly type = 'RemoveChecklistItemAction';

  constructor(public bijbEvent: BijbEvent, public checklistItem: ChecklistItem) {
  }

  public type = RemoveChecklistItemAction.type;
}
